export enum OrderStatusTypeEnum {
  Draft = 0,
  Created = 1,
  Confirmed = 2,
  Failed = 3,
  Partially_fulfilled = 4,
  Concluded = 5,
  Cancelled = 6,
  Syncing = 7,
}
